import { Button, Modal, Popconfirm, Space, Spin } from "antd";
import { Eye, HelpCircle, Pencil, Trash2 } from "lucide-react";
import { Question } from "@types";
import { useTranslation } from "react-i18next";
import { useDeleteExamGroupQuestions } from "@hooks";
import { BankPoolForm } from "@components";
import { Suspense, useState } from "react";
import { useExamStore } from "../../store/useExamStore";
import { ExamContent } from "../question-preview/ExamContent";
// import { useQueryClient } from "@tanstack/react-query";

interface Props {
  question: Question;
  groupId: string;
  examPeriodScreen?: boolean;
}

export const QuestionTableActions = ({ question, groupId, examPeriodScreen }: Props) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const deleteQuestion = useDeleteExamGroupQuestions(groupId);
  const setClickedQuestion = useExamStore((state) => state.setClickedQuestion);

  return (
    <div>
      <Space>
        <Button icon={<Eye />} onClick={() => {
          setClickedQuestion(question);
          setIsPreviewOpen(true);
        }}/>
        
        {!examPeriodScreen && (
          <>
          <Button onClick={() => setIsModalOpen(true)} icon={<Pencil />} />
          <Popconfirm
            title={t("pages.examsManagment.examQuestionsTab.deleteQuestion")}
            description={t("pages.examsManagment.examQuestionsTab.deleteQuestionDesc")}
            onConfirm={() => deleteQuestion.mutate([question])}
            okButtonProps={{ loading: deleteQuestion.isPending }}
            
            icon={<HelpCircle style={{ color: "red", marginRight: 8 }} />}
          >
            <Button danger icon={<Trash2 />} />
          </Popconfirm>
        </>
        )}
      </Space>
      <Modal
          title={t("pages.bankPool.editQuestion")}
          footer={null}
          onCancel={() => setIsModalOpen(false)}
          destroyOnClose
          styles={{ body: {
            paddingRight: 8,
            paddingLeft: 4,
            height: "calc(80vh - 30px)",
            overflowY: "auto",
          } }}
          maskClosable={false}
          open={isModalOpen}
        >
          <Suspense fallback={<Spin/>}>
            <BankPoolForm
              setIsModalOpen={setIsModalOpen}
              selectedGroup={groupId}
              examQuestionType={question.questionType.id}
              question={question}
            />
          </Suspense>
        </Modal>

        <Modal 
          title={t("pages.bankPool.preview")}
          footer={null}
          onCancel={() => setIsPreviewOpen(false)}
          destroyOnClose
          width={1000}
          open={isPreviewOpen}
        >
          <ExamContent />
          </Modal>
    </div>
  );
};
